// Styles
import "./dialog-input.scss";
// Tools
import { useState } from "react";
import { useSelector } from "react-redux";
// Types
import { RootState } from "../../../../../../../../../../shared/store/store";

type Props = {
	inputValue: string;
	setInputValue: (value: string) => void;
	handleSendMessage: (inputValue: string) => void;
};

export const DialogInput = ({
	inputValue,
	setInputValue,
	handleSendMessage,
}: Props) => {
	const isFreezeUI: boolean = useSelector(
		(state: RootState) => state.session.freezeUI,
	);

	return (
		<div className='dialog-input'>
			<div className='dialog-input__wrapper'>
				<div className='dialog-input__textarea-wrapper'>
					<input
						value={inputValue}
						onKeyDown={(event) => {
							if (event.key === "Enter") {
								handleSendMessage(inputValue);
							}
						}}
						onChange={(event) => setInputValue(event.target.value)}
						type='text'
						className={`dialog-input__textarea ${isFreezeUI ? "disabled" : ""}`}
						disabled={isFreezeUI}
					/>
				</div>
				<div className='dialog-input__button-input'>
					<button
						onClick={() => handleSendMessage(inputValue)}
						className={`dialog-input__button ${inputValue.length === 0 || isFreezeUI ? "disabled" : ""}`}>
						<img src='/img/icons/send.png' alt='send icon' />
					</button>
				</div>
			</div>
		</div>
	);
};
